import { DataContext } from 'entries/common/widgets/context';
import { useContext, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getCookie } from 'utils/cookie.helper';
import { useIsFloorCalculator } from './use-is-floor-calculator.hook';
import {
  SEARCH_CONFIGURATIONS_DEFAULT_PAGE,
  SEARCH_CONFIGURATIONS_DEFAULT_SIZE,
  CUSTOMER_ID_COOKIE_NAME,
  UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME,
  SEARCH_CONFIGURATIONS_ENDPOINT,
} from '../const';
import { roomsAtom } from '../store/rooms';
import { TSearchConfigurationsResponse } from '../types';
import { getSearchConfigurationsBody } from '../helpers/get-search-configurations-body';
import { parseSearchConfigurationsResponse } from '../helpers/parse-search-configurations-response';
import { clearRoomsStorage } from '../helpers/clear-rooms-storage';

export const useGetRooms = () => {
  const data = useContext(DataContext);
  const calculatorId = data?.surfaces?.id || '';
  const isFloorCalculatorId = useIsFloorCalculator();
  const calculatedRooms = useRecoilValue(roomsAtom);
  const setRoomsState = useSetRecoilState(roomsAtom);
  const apiMethods = data!.api;
  const authorizedCustomerId = getCookie(CUSTOMER_ID_COOKIE_NAME);
  const unauthorizedCustomerId = getCookie(UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME);
  const isAnyCustomerIdExists = Boolean(authorizedCustomerId) || Boolean(unauthorizedCustomerId);

  useEffect(() => {
    clearRoomsStorage();
    async function getRooms() {
      const body = getSearchConfigurationsBody(authorizedCustomerId, unauthorizedCustomerId);
      try {
        const configurations: TSearchConfigurationsResponse = await apiMethods.post(
          `${SEARCH_CONFIGURATIONS_ENDPOINT}?page=${SEARCH_CONFIGURATIONS_DEFAULT_PAGE}&size=${SEARCH_CONFIGURATIONS_DEFAULT_SIZE}`,
          body
        );
        const rooms = parseSearchConfigurationsResponse(configurations, calculatorId);
        setRoomsState(rooms);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('get rooms failed', e);
      }
    }

    if (isFloorCalculatorId && calculatedRooms.length === 0 && isAnyCustomerIdExists) {
      getRooms();
    }
  }, [apiMethods, calculatedRooms.length, calculatorId, isFloorCalculatorId, setRoomsState]);
};
